import { render, staticRenderFns } from "./loginUser.vue?vue&type=template&id=f96d87a6&scoped=true"
import script from "./loginUser.vue?vue&type=script&lang=js"
export * from "./loginUser.vue?vue&type=script&lang=js"
import style0 from "./loginUser.vue?vue&type=style&index=0&id=f96d87a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96d87a6",
  null
  
)

export default component.exports